import React, { useState, useEffect, useRef } from 'react'

import { Button, Divider, Grid, Paper } from '@mui/material'

import colors from '../../../config/colors'

import useSetTitlePage from '../../hooks/useSetTitlePage'

import { labelTitlePrestador } from '../../global/styles'

import CustomLabel from '../../components/common/customLabel'

import * as apiService from '../../../api'

import UseIconHooks from '../../hooks/useIconHooks'

import ModalLoading from '../../components/common/modalLoading'

import { format } from 'date-fns'

import { useParams } from 'react-router-dom'

import { useNavigate } from 'react-router-dom'
import PagoItem from '../../components/pagos/pagoItem'
import CustomConfirmModal from '../../components/common/customConfirmModal'
import { useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'

const Pagos = () => {

	const [session,setSession] = useState("")
	const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado)
	const [pagos, setPagos] = useState([])
	const [loading, setLoading] = useState(false)
	const [openConfirmModal, setOpenConfirmModal] = useState(false)
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const handlerCloseConfirmModal = () => {
		setOpenConfirmModal(false)
		setPagoActual({})
	}

	const [messageConfirmModel, setMessageConfirmModel] = useState('')
	const [pagoActual, setPagoActual] = useState({})

	const noHandlerMethod = () => {
		handlerCloseConfirmModal()
	}

	const yesHandlerMethod = () => {
		handlerRealizarPago(pagoActual)
	}

	const formPago = useRef(null)

	const [montoTotal, setMontoTotal] = useState('')
	const [factura, setFactura] = useState('')
	const [ordenCompra, setOrdenCompra] = useState('')

	let params = useParams()

	var navigate = useNavigate()

	useEffect(() => {
		if (localStorage.getItem('autenticado') == 'false') navigate('../../login', { replace: true })

		apiService.pagos
		.postConciliarPagoPendiente(infoAfiliado.codigoAfiliado)
		.then(response => {
			console.log(response)
		})
		.catch(err=> {
			console.log(err)
		})
		
		setLoading(true)
		apiService.pagos
			.getAllFacturaPendientePago(infoAfiliado.codigoAfiliado)
			.then((response) => {
				response.data.map((item) => {
					item.fechaFacturacion = format(new Date(item.fechaFacturacion), 'yyyy-MM-dd')
					item.fechaLimitePago = format(new Date(item.fechaLimitePago), 'yyyy-MM-dd')
				})
				setPagos(response.data)
				setLoading(false)
			})
			.catch((err) => console.log(err))
	}, [])

	const TitlePagos = (
		<>
			<CustomLabel style={{ ...labelTitlePrestador }}>Gestión de pagos</CustomLabel>
			<Divider />
			<br />
			<br />
		</>
	)

	useSetTitlePage(TitlePagos)

	const handlerRealizarPago = (value) => {
		setLoading(true)
		setFactura(value.numeroFactura)
		setMontoTotal(value.montoTotal)
		apiService.pagos
			.getOrdenCompraGenerada(value.numeroFactura, value.montoTotal, infoAfiliado.codigoAfiliado)
			.then((response) => {
				setOrdenCompra(response.data.numeroOrden)
				const body = {
					ordenId: response.data.numeroOrden.toString(),
					transactionId: value.numeroFactura.toString(),
					amount: value.montoTotal.toString()
				  }
				  apiService.pagos.postGenerarSession(body,infoAfiliado.codigoAfiliado,false,response.data.idOrdenFactura)
				  .then(response => {
					if (response.data.result)
					{
					  setSession(response.data.result.session)
					  setTimeout(() => {
						setLoading(false)
						formPago.current.submit()
						
					  },100)
					 
					}
				   
				  })
				  .catch(err => {
					console.log(err)
					setLoading(false)
				  })
			})
			.catch((err) => {
				setLoading(false)
				console.log(err)
			})
	}

	const abrirConfirmModal = (pago) => {
		if (pago.estatusFactura !== "Procesando") {
			setPagoActual(pago)
			setMessageConfirmModel('¿Desea realizar este pago?')
			setOpenConfirmModal(true)
		} else {
			enqueueSnackbar("Se esta procesando el pago de esta factura.", {
				variant: "warning",
				action: (key) => (
				  <Button style={{ color: 'white', fontWeight: 'bold' }} onClick={() => closeSnackbar(key)}>
					X
				  </Button>
				)
			  });
		}
	}

	return (
		<>
			{' '}
			<form ref={formPago} action={process.env.REACT_APP_CARDNET_URL} method='post'>
				<Grid container>
					<Grid item xs={12}>
						<CustomLabel
							style={{
								fontFamily: 'Montserrat',
								fontSize: 25,
								fontWeight: 'bold'
							}}
						>
							Listado de facturas
						</CustomLabel>
					</Grid>
					<Grid item xs={12}>
						{pagos && pagos.length !== 0 ? (
							<>
								<Paper
									elevation={2}
									style={{
										height: 450,
										width: '100%',
										padding: 15,
										overflow: 'scroll',
										overflowX: 'hidden'
									}}
								>
									{pagos.map((pago) => (
										<Paper
											elevation={5}
											key={pago.numeroFactura.toString()}
											style={{
												cursor: 'pointer'
											}}
											onClick={() => abrirConfirmModal(pago)}
										>
											<PagoItem
												numeroFactura={pago.numeroFactura}
												estatus={pago.estatusFactura}
												fechaFactura={pago.fechaFacturacion}
												fechaLimitePago={pago.fechaLimitePago}
												montoTotal={pago.montoTotal}
											/>
										</Paper>
									))}
								</Paper>
							</>
						) : (
							<CustomLabel
								style={{
									fontFamily: 'Montserrat',
									fontSize: 18,
									fontWeight: 'bold',
									marginTop: 20
								}}
							>
								No cuenta con factura(s) pendiente(s).
							</CustomLabel>
						)}
					</Grid>
				</Grid>

				<ModalLoading open={loading} onCloseHandler={() => setLoading(false)} />

				<CustomConfirmModal
					open={openConfirmModal}
					closeHandler={handlerCloseConfirmModal}
					mensaje={messageConfirmModel}
					yesHandler={yesHandlerMethod}
					noHandler={noHandlerMethod}
				/>

			<p>
          		<input name='SESSION' value={session} type='hidden' />
        	</p>

			</form>
		</>
	)
}

export default Pagos
